import * as React from 'react';
import { Body1 } from '@cian/ui-kit';

import { CloseButton } from '../CloseButton';
import * as styles from './styles.css';

export interface IHeaderProps {
  name?: string;
  favorite?: React.ReactNode;
  call?: React.ReactNode;
  chat?: React.ReactNode;
  onClose(): void;
}

export function Header({ name, favorite, call, chat, onClose }: IHeaderProps): React.JSX.Element {
  return (
    <div className={styles['container']} data-testid="FullscreenGalleryHeader">
      {name && (
        <div>
          <Body1 fontWeight="700">ЖК «{name}»</Body1>
        </div>
      )}
      <div className={styles['button-group']}>
        {call}
        {chat}
        {favorite}
        <div className={styles['close']}>
          <CloseButton onClick={onClose} />
        </div>
      </div>
    </div>
  );
}
